<template>
    <span>
        <!-- Menú lateral que aparece sólo cuando drawer == true, siendo ésto posible sólo en ventanas sm y menores: -->
        <v-navigation-drawer
            v-if="isAuthenticated && showHeader"
            app
            v-model="drawer"
            class="grey lighten-5"
            disable-resize-watcher
        >
            <v-list dense class="pt-0">
                
                <v-list-item>
                    <v-list-item-title>
                        <v-icon color="red darken-2">mdi-account</v-icon>&nbsp;{{ userName }}
                    </v-list-item-title>
                </v-list-item>

                <v-list-item v-if="userType === 2">
                    <v-list-item-title>
                        <v-icon color="red darken-2">mdi-card-account-details-outline</v-icon>&nbsp;{{ numCuenta }}
                    </v-list-item-title>
                </v-list-item>

                <v-list-item v-if="userType === 2">
                    <v-list-item-title>
                        <v-icon color="red darken-2">mdi-school</v-icon>&nbsp;{{ carrera }}
                    </v-list-item-title>
                </v-list-item>
                <v-list-item>
                    <v-list-item-title class="caption">
                        <v-icon color="red darken-2">mdi-chart-gantt</v-icon>&nbsp;{{ nombrePlan }}
                    </v-list-item-title>
                </v-list-item>
                
                <!-- Administradores: -->
                <v-list-item v-if="userType === 1" @click="onCatalogoAOCS">
                    <v-list-item-action>
                        <v-icon color="red darken-2">mdi-map-outline</v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                        <v-list-item-title>AOCs</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>

                <!-- Administradores: -->
                <v-list-item v-if="userType === 1" @click="onUsuarios">
                    <v-list-item-action>
                        <v-icon color="red darken-2">mdi-account-multiple</v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                        <v-list-item-title>Administradores</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>

                <v-divider></v-divider>

                <v-list-item @click="onLogout">
                    <v-list-item-action>
                        <v-icon color="red darken-2">mdi-exit-to-app</v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                        <v-list-item-title>Salir</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
            </v-list>
        </v-navigation-drawer>
        <!-- Termina menú lateral para dispositivos con ventanas sm y menores-->

        <!-- prominent -->
        <v-app-bar
            v-if="isAuthenticated && showHeader"
            color="red darken-4"
            dark
            elevation="2"
            fixed
            app
            height="128"
            clipped-left
            src="@/assets/fondo1a.jpg"
        >
            <template v-if="$vuetify.breakpoint.mdAndUp" v-slot:img="{ props }">
                <v-img
                v-bind="props"
                gradient=".25turn, rgba(183, 28, 28, 1), 70%, rgb(255,235,238, 1)"
                ></v-img>
            </template>
            <template v-else v-slot:img="{ props }">
                <v-img
                v-bind="props"
                gradient=".25turn, rgb(183, 28, 28, 1), 55%, rgb(255,235,238, 1)"
                ></v-img>
            </template>
            
            <v-app-bar-nav-icon
                v-if="isAuthenticated"
                class="hidden-md-and-up"
                @click="drawer = !drawer"
            ></v-app-bar-nav-icon>

            <router-link to="/">
                <img height="110" :src="uiaRubricaSimple" @click="onHome" class="logo-hover"/>
            </router-link>

            <!-- Alumnos: -->
            <v-toolbar-title v-if="userType === 2" class="hidden-sm-and-down">
                <v-container class="pa-0 ml-3" fill-height>
                    <v-row align="center" justify="center" class="ma-0 pa-0">
                        <v-col cols="12" class="subtitle-1 ma-0 pa-0" align-self="start">
                            {{ userName }}
                        </v-col>
                    </v-row>
                    <v-row align="center" justify="center" class="ma-0 pa-0">
                        <v-col cols="12" class="subtitle-1 ma-0 pa-0" align-self="start">
                            {{ numCuenta }}
                        </v-col>
                    </v-row>
                    
                </v-container>
            </v-toolbar-title>

            <!-- Alumnos: -->
            <v-toolbar-title v-if="userType === 2" class="hidden-sm-and-down">
                <v-container fill-height>
                    <v-row align="center" justify="center">
                        <v-col cols="12" class="caption font-weight-bold" align-self="start">
                            Alumno
                        </v-col>
                    </v-row>
                    
                </v-container>
            </v-toolbar-title>

            <!-- Administradores: -->
            <v-toolbar-title v-if="userType === 1" class="hidden-sm-and-down">
                <v-container>
                    <v-row align="center">
                         <v-col class="subtitle-1 justify-center">
                            {{ userName }}
                        </v-col> 
                    </v-row>
                </v-container>
            </v-toolbar-title>

            <v-spacer class="hidden-sm-and-down"></v-spacer>

            <v-spacer></v-spacer>
            
            <v-toolbar-items class="hidden-sm-and-down">
                <!-- Alumnos: -->    
                <v-btn v-if="(userType === 2)" text class="text-none" @click="onMyAOCs">
                    <v-icon>mdi-certificate</v-icon>&nbsp;Mis AOCs
                </v-btn>
                    

                <!-- Administradores: -->
                <v-menu v-if="(userType === 1)" offset-y>
                    <template v-slot:activator="{ on }">
                        <v-btn text class="text-none" v-on="on">
                            <v-icon>mdi-cog</v-icon>&nbsp;Configuración</v-btn>
                    </template>
                    <v-list color="grey lighten-5">

                        <v-list-item v-if="(userType === 1)" @click="onCatalogoAOCS">
                            <v-list-item-title>
                                <v-icon color="red darken-4">mdi-map-outline</v-icon>&nbsp; Asignaturas Optativas Complementarias
                            </v-list-item-title>
                        </v-list-item>

                        <v-list-item v-if="(userType === 1)" @click="onDivisiones">
                            <v-list-item-title>
                                <v-icon color="red darken-4">mdi-file-tree-outline</v-icon>&nbsp; Divisiones
                            </v-list-item-title>
                        </v-list-item>
                    </v-list>                   
                </v-menu>
                <!-- Administradores: -->
                <v-btn
                    v-if="userType === 1"
                    text
                    class="text-none"
                    @click="onUsuarios">
                    <v-icon>mdi-account-multiple</v-icon>&nbsp;Administradores
                </v-btn>
                
                <!-- Todos: -->
                <v-btn
                    text
                    class="text-none"
                    @click="onLogout">
                    <v-icon>mdi-exit-to-app</v-icon>&nbsp;Salir</v-btn
                >
            </v-toolbar-items>
            <img height="90" :src="logoAOCS"/>
            <!-- Fin del menú visible si se inició sesión -->
        </v-app-bar>
    </span>
</template>

<script>
import { mapGetters } from 'vuex';
import LocaleChanger from '@/components/LocaleChanger';

export default {
    name: 'AppNavigation',
    data() {
        return {
            drawer: false,
            overlay: false,
        };
    },
    components: {
        LocaleChanger,
    },
    methods: {
        onHome() {
            if (!this.isAuthenticated) {
                this.drawer = false;
            }
        },
        
        onUsuarios() {
            this.$router.push('/users');
            this.drawer = false;
        },
        
        onCatalogoAOCS() {
            this.$router.push('/catalogo_aocs');
            this.drawer = false;
        },

        onDivisiones() {
            this.$router.push('/divisiones');
            this.drawer = false;
        },

        onMyAOCs() {
            this.myAOCsDlg = true;
        },

        onLogout() {
            this.$store.dispatch('logout');
            this.drawer = false;
        },
        
    },
    computed: {
        ...mapGetters([
            'appTitle',
            'uiaLogoBlanco',
            'uiaRubricaSimple',
            'logoAOCS',
            'isAuthenticated',
            'userType',
            'userName',
            'carrera',
            'numCuenta',
            'semestres',
            'planEstudios',
            'showHeader',
        ]),

        nombrePlan(){
            var strPlan = '';
            if (this.planEstudios !== null)
            {
                strPlan = this.planEstudios.nombrePlan;
            }
            return strPlan;
        },

        myAOCsDlg: {
            get() {
                return this.$store.getters.myAOCsDlg;
            },
            set(myAOCsDlg) {
                this.$store.dispatch('updateMyAOCsDlg', myAOCsDlg)
            },
        },
        
    },
};
</script>

<style scoped>
h5 {
    /* color: 'teal darken-1'; */
    color: #00897b;
}

.logo-hover:hover {
    cursor: pointer;
}

.usr-name {
    font-size: 14px;
    color: #00897b;
}

.centenario-brown {
    color: #6c3200;
}

.arq-main {
    color: #303f9f
}


a:link,
a:visited {
    color: black;
    text-decoration: none;
}

a:link:active,
a:visited:active {
    color: black;
}
</style>
